import { render, staticRenderFns } from "./NibPerBulan.vue?vue&type=template&id=cde2266c&scoped=true&"
import script from "./NibPerBulan.vue?vue&type=script&lang=js&"
export * from "./NibPerBulan.vue?vue&type=script&lang=js&"
import style0 from "./NibPerBulan.vue?vue&type=style&index=0&id=cde2266c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde2266c",
  null
  
)

export default component.exports